import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { entitiesActions } from '../store/entities';
import { useTranslation } from 'react-i18next';
import { investorLocalizationApi } from '@/api';
import { getCountries } from '@/modules/kycModule';
import { queryClient } from '@/app/QueryClientProvider';
import { StaticsApi } from '@/api/statics';
import { LANGUAGES } from '@/app/localization/static';
import { COUNTRIES_FULL_LIST } from '@/utils/static';

export const useCountries = () => {
  const dispatch = useDispatch();
  const { i18n } = useTranslation();
  const { countries, languages } = useSelector((state) => state.entities);

  const getAvailableLanguages = useCallback(async () => {
    try {
      const result = await investorLocalizationApi.getAvailableLanguages();
      if (result) dispatch(entitiesActions.setLanguages(result.data));
    } catch (e) {
      console.error('FETCH_LANGUAGES', e);
      dispatch(entitiesActions.setLanguages(LANGUAGES));
    }
  }, [dispatch]);

  const changeCurrentLanguage = useCallback(
    (value) => {
      const newLang = languages.find((i) => i.code === value.key)?.code?.toLowerCase();
      const newLangId = languages.find((i) => i.code === value.key)?.id;

      i18n.changeLanguage(newLang).then(() => {
        localStorage.setItem('language', newLang);
        queryClient.fetchQuery({
          queryKey: ['StaticsApi.getStatics'],
          queryFn: () => StaticsApi.getStatics({ languageId: newLangId })
        });
      });
    },
    [languages, i18n]
  );

  const setCountries = useCallback(async () => {
    if (languages) {
      try {
        const currentLang = languages.find((i) => i.code === 'EN');
        const resCountries = await getCountries(currentLang.id);
        if (resCountries) dispatch(entitiesActions.setCountries(resCountries.data));
      } catch (e) {
        console.error('FETCH_COUNTRIES', e);
        dispatch(entitiesActions.setCountries(COUNTRIES_FULL_LIST));
      }
    }
  }, [dispatch, languages]);

  return {
    languages,
    countries,
    setCountries,
    getAvailableLanguages,
    changeCurrentLanguage
  };
};
